class LocalizationFormComponent extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.languageInput = null;
    this.countryInput = null;
    this.countryInputItems = null;
    this.countryCustomSelect = null;
    this._boundCloseOnClickOutside = null;
  }

  connectedCallback() {
    this.form = this.querySelector('form.localization-form');
    this.languageInput = this.querySelector('[data-ref="language-input"]');
    this.countryInput = this.querySelector('[data-ref="country-input"]');
    this.countryInputItems = this.querySelectorAll('[data-ref="country-input-item"]');
    this.countryCustomSelect = this.querySelector('[data-ref="country-custom-select"]');

    if (this.countryCustomSelect) {
      this.#setupCountryCustomSelect();
    } else if (this.countryInput instanceof HTMLSelectElement) {
      this._countrySelectHandler = () => this.form?.submit();
      this.countryInput.addEventListener('change', this._countrySelectHandler);
    } else {
      this.countryInputItems.forEach((countryInputItem) => {
        countryInputItem.addEventListener('click', (event) => {
          this.selectCountry(countryInputItem.dataset.value, event);
        });
      });
    }

    this.languageInput?.addEventListener('change', (event) => {
      this.changeLanguage(event);
    });
  }

  #setupCountryCustomSelect() {
    const trigger = this.countryCustomSelect.querySelector('[data-ref="country-custom-trigger"]');
    const dropdown = this.countryCustomSelect.querySelector('[data-ref="country-custom-dropdown"]');
    const options = this.countryCustomSelect.querySelectorAll('[data-ref="country-custom-option"]');

    if (!trigger || !dropdown) return;

    this._boundCloseOnClickOutside = (e) => {
      if (this.countryCustomSelect?.contains(e.target)) return;
      this.#closeCountryDropdown();
    };

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        this.#closeCountryDropdown();
      } else {
        this.#openCountryDropdown(trigger, dropdown);
        document.addEventListener('click', this._boundCloseOnClickOutside);
      }
    });

    for (const option of options) {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        this.#selectCountryOption(option);
      });
      option.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.#selectCountryOption(option);
        }
      });
    }
  }

  #selectCountryOption(option) {
    const value = option.dataset.value;
    const currency = option.dataset.currency;
    const flagUrl = option.dataset.flagUrl;
    const valueEl = this.countryCustomSelect.querySelector('[data-ref="country-custom-value"]');
    const flagEl = this.countryCustomSelect.querySelector('[data-ref="country-custom-flag"]');

    if (this.countryInput) this.countryInput.value = value;
    if (valueEl) valueEl.textContent = currency;
    if (flagEl && flagUrl) flagEl.style.backgroundImage = `url(${flagUrl})`;

    this.countryCustomSelect.querySelectorAll('[data-ref="country-custom-option"]').forEach((opt) => {
      opt.classList.remove('localization-form__country-custom-select__option--selected');
      if (opt.dataset.value === value) opt.classList.add('localization-form__country-custom-select__option--selected');
    });

    this.#closeCountryDropdown();
    this.form?.submit();
  }

  #openCountryDropdown(trigger, dropdown) {
    const rect = trigger.getBoundingClientRect();
    dropdown.hidden = false;
    dropdown.classList.add('localization-form__country-custom-select__dropdown--fixed');
    dropdown.style.top = 'auto';
    dropdown.style.bottom = `${window.innerHeight - rect.top + 4}px`;
    dropdown.style.left = `${rect.left}px`;
    dropdown.style.width = '50vw';
    dropdown.style.minWidth = '50vw';
    trigger.setAttribute('aria-expanded', 'true');
  }

  #closeCountryDropdown() {
    const trigger = this.countryCustomSelect?.querySelector('[data-ref="country-custom-trigger"]');
    const dropdown = this.countryCustomSelect?.querySelector('[data-ref="country-custom-dropdown"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (dropdown) {
      dropdown.hidden = true;
      dropdown.classList.remove('localization-form__country-custom-select__dropdown--fixed');
      dropdown.style.top = '';
      dropdown.style.bottom = '';
      dropdown.style.left = '';
      dropdown.style.width = '';
      dropdown.style.minWidth = '';
    }
    document.removeEventListener('click', this._boundCloseOnClickOutside);
  }

  disconnectedCallback() {
    if (this.countryCustomSelect && this._boundCloseOnClickOutside) {
      document.removeEventListener('click', this._boundCloseOnClickOutside);
    }
    if (this.countryInput instanceof HTMLSelectElement && this._countrySelectHandler) {
      this.countryInput.removeEventListener('change', this._countrySelectHandler);
    } else if (!this.countryCustomSelect) {
      this.countryInputItems.forEach((countryInputItem) => {
        countryInputItem.removeEventListener('click', (event) => {
          this.selectCountry(countryInputItem.dataset.value, event);
        });
      });
    }

    this.languageInput?.removeEventListener('change', (event) => {
      this.changeLanguage(event);
    });
  }

  selectCountry = (countryName, event) => {
    event.preventDefault();

    this.countryInput.value = countryName;
    this.form?.submit();
  };

  changeLanguage(event) {
    const value = event.target instanceof HTMLSelectElement ? event.target.value : null;

    if (value) {
      this.languageInput.value = value;
      this.form?.submit();
    }
  }
}

if (!customElements.get('localization-form-component')) {
  customElements.define('localization-form-component', LocalizationFormComponent);
}
